export default {"src":"/hub/_next/static/media/user-icon.db751d1b.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};